import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import Modal from '../../modal'
import Icon from '../../icon'
import Button from '../../../baseComponent/button'
import './index.less'

export default (props) => {
  const div = props?.root || document.createElement('div')
  return new Promise(() => {
    ReactDOM.render(<NoPermission {...props} visible container={div} />, div)
  })
}

export const NoPermission = ({ visible, onCancel, onOk }) => {
  const [_visible, set_Visible] = useState(visible)
  const _cancel = () => {
    onCancel && onCancel()
    set_Visible(false)
  }
  const _ok = async () => {
    const flag = await onOk?.()
    if (flag === false) {
      return
    }
    set_Visible(false)
  }

  return <Modal
    style={{ width: '416px', minHeight: 'unset' }}
    visible={_visible}
    onCancel={_cancel}
    onOk={_ok}
    className="mn-prompt-modal"
    hiddenFooter
  >
    <div className="mn-permission-prompt">
      <div className="mn-permission-page-modal-info">
        <Icon type="m-zhuyi_tianchong" className="mn-permission-page-modal-info-icon" />
        <div className="mn-permission-page-modal-info-text">
          专业版功能，您当前版本为基础版无权限使用
        </div>
      </div>
      <div className="mn-permission-page-modal-footer">
        <Button type="normal" onClick={() => window.open('/meinian/home/version', '_self')}>查看更多版本权益</Button>
      </div>
    </div>
  </Modal>
}
